import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "computerWithEyeAndChip",
    iconColor: "white",
    text: "Data & AI \nOperations \nCommand Center",
    listItemCustomStyle: { width: "200px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "screenWithDollarSignAndGear",
    iconColor: "white",
    text: "Over 40% \nreduction in \nplatform \noperations cost",
    listItemCustomStyle: { width: "200px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "cloudWithScheme",
    iconColor: "white",
    text: "Over 50% \nreduction in cloud \nconsumption cost",
    listItemCustomStyle: { width: "200px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithPolice",
    iconColor: "white",
    text: "Up to 40% faster \nresolution of \ntickets with \nCognitive self-\nhealing",
    listItemCustomStyle: { width: "250px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_DNA1 = {
  styleLeftPanel: { paddingRight: 0 },
  title: "End-to-end data \noperations",
  text: "The Infosys Operations Workbench provides end-to-end observability, Data, \nAI and FinOps across entire data & AI estate.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage(102),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_01.jpg",
  rightSideImage: "DNA1/DNA1_INTRO_1_Cycle.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
};
